import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getInventoryByShopId, getShortOrderByNumber, } from '../../selectors';

import { getIdentityUtils } from '../../utils';

import { createConfirmationForDeletePopup, createCopyOrderPopup } from '../../actions/popup';
import { deleteShop } from '../../actions/shop';

import DropdownMenu, { MenuTrigger } from '../DropdownMenu';
import { H1 } from '@commonsku/styles';
import { isConnectedShop, isMarketingShop, isPopupShop, isPODShop } from './helpers';

// Label shown in the shop title bar for each shop type.
function getShopTitleLabel(shop) {
  if (isConnectedShop(shop)) return 'Shopify Connected Shop';
  if (isPopupShop(shop)) return 'Pop-up Shop';
  if (isMarketingShop(shop)) return 'Marketing Shop';
  if (isPODShop(shop)) return 'Print on Demand Shop';
  return 'Company Shop';
}

// String key the CopyOrderPopup expects to pre-select the target shop type.
// Note: the popup's legacy enum uses 'shopify' rather than 'connected'.
function getCopyPopupShopTypeKey(shop) {
  if (isConnectedShop(shop)) return 'shopify';
  if (isPopupShop(shop)) return 'popup';
  if (isMarketingShop(shop)) return 'marketing';
  if (isPODShop(shop)) return 'pod';
  return 'company';
}

class Title extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showFullName: false
    };

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter() {
    this.setState({ showFullName: true });
  }

  handleMouseLeave() {
    this.setState({ showFullName: false });
  }

  render() {
    const { shop, identity, inventory, order, onDeleteShop } = this.props;

    const { hasCapabilities } = getIdentityUtils(identity);
    const pathname = window.location.pathname;

    const isHeadlessShop = shop?.is_headless;
    const isHeadlessOrderPage = isHeadlessShop && pathname.endsWith('/orders');

    const isInventoryValid = !!inventory &&
      !!inventory.inventory_name &&
      !!inventory.warehouse &&
      !!inventory.warehouse.warehouse_name &&
      !!inventory.warehouse.division_id &&
      !!inventory.warehouse.shipping_address_id &&
      !!inventory.warehouse.contact_id;

    const actionOptions = [
      {
        value: 'Copy Shop',
        hideOnClick: true,
        onClick: () => {
          this.props.onCreateCopyOrderPopup(order, getCopyPopupShopTypeKey(shop));
        },
        show: hasCapabilities('CREATE-SHOP') && !isHeadlessShop,
      },
      {
        value: <a href={`/shop/${shop.shop_id}`} target="_blank">Preview Shop</a>,
        hideOnClick: true,
        show: !isHeadlessShop
      },
      {
        value: <a href={`/send_email.php?parent_type=shop&parent_id=${shop.shop_id}`} target="_blank">Email Shop</a>,
        hideOnClick: true,
        show: !isHeadlessShop
      },
      {
        value: <a href={`/shop/${shop.shop_id}/shop?buy_inventory=true`} target="_blank">Order Inventory</a>,
        hideOnClick: true,
        show: isInventoryValid
      },
      {
        value: 'Delete Shop',
        className: 'alert',
        hideOnClick: true,
        onClick: () => onDeleteShop(),
        show: hasCapabilities('DELETE-SHOP')
      }
    ].filter(o => o.show);

    const clientUrl = `/client.php?id=${shop.client_id}`;
    const shopTitle = `${getShopTitleLabel(shop)} #${shop.shop_number}`;
    return (
      <div className="columns" style={{margin: 'auto 0'}}>
        {isHeadlessOrderPage ? <H1 style={{ display: 'inline-block', marginBottom: 0, fontWeight: 500, fontSize: 32 }}>Imported Checkouts</H1> :
        <h4 style={{ display: 'inline-block' }}>
          {shop.client_id && <a href={clientUrl} target="_blank">{_.get(shop, ['client', 'client_name'], '')}</a>}
          {shop.client_id && <span> — </span>}
          <span>
            {shopTitle}&nbsp;
            <span onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
              {shop.shop_name.length > 30 && !this.state.showFullName ? shop.shop_name.substring(0, 30) + '...' : shop.shop_name }
            </span>
          </span>
        </h4>
        }
        <DropdownMenu style={{ float: 'right' }} className="actions-dropdown" options={actionOptions} align="right">
          <MenuTrigger>
            <a className="button actions-dropdown-button alt bold trigger-button" style={{ marginBottom: '0.5rem' }}>Actions</a>
          </MenuTrigger>
        </DropdownMenu>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  identity: state.identity,
  inventory: getInventoryByShopId(state, ownProps.shop),
  order: getShortOrderByNumber(state, { form_number: ownProps.shop.shop_number, order_type: 'SHOP' }),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onDeleteShop: () => dispatch(createConfirmationForDeletePopup(() => dispatch(deleteShop(ownProps.shop.shop_id)), [], 'shop', ownProps.shop.shop_name)),
  onCreateCopyOrderPopup: (order, shop_type=null) => dispatch(createCopyOrderPopup(order, 'SHOP', shop_type)),
});

const ConnectedTitle = connect(mapStateToProps, mapDispatchToProps)(Title);
export default ConnectedTitle;
